import { toArray } from '@wix/wow-utils';
const name = 'SlideHorizontal';
const properties = {
    defaultDuration: 0.6,
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        reverse: {
            type: 'boolean',
            default: false,
        },
        width: {
            type: 'number',
            min: 0,
        },
    },
};
/**
 * Slide an element out and another in from left tot right.
 */
function transition(kit, sourceElements, destElements, duration, delay, { reverse = properties.schema.reverse.default, width, ease = 'Strong.easeInOut', ...params } = {}) {
    const direction = reverse ? -1 : 1;
    sourceElements = toArray(sourceElements);
    width = width ?? sourceElements[0].offsetWidth;
    const sequence = kit.sequence(params);
    sequence.add([
        kit.animate('BaseFade', destElements, 0, delay, {
            to: { opacity: 1 },
            immediateRender: false,
        }),
        kit.animate('BasePosition', sourceElements, duration, delay, {
            from: { x: 0 },
            to: { x: -width * direction },
            ease,
        }),
        kit.animate('BasePosition', destElements, duration, delay, {
            from: { x: width * direction },
            to: { x: 0 },
            ease,
        }),
    ]);
    return sequence.get();
}
export { name, properties, transition };
//# sourceMappingURL=slideHorizontal.js.map